class CollectionLoader extends HTMLElement {
  static get observedAttributes() {
    return ['message', 'active'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    this.shadowRoot.innerHTML = `
      <style>
        .wrapper {
          position: fixed;
          z-index: 99999;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background: rgba(255,255,255,0.75);
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          pointer-events: none;
          transition: opacity .25s ease;
        }
        .wrapper.active {
          opacity: 1;
          pointer-events: all;
        }
        .loader {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          font-size: 1.1rem;
          color: #333;
        }
        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #333;
          border-top-color: transparent;
          border-radius: 50%;
          animation: spin .7s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
      </style>

      <div class="wrapper">
        <div class="loader">
          <div class="spinner"></div>
          <span class="text"></span>
        </div>
      </div>
    `;
  }

  connectedCallback() {
    this.updateMessage();
    this.updateActive();
  }

  attributeChangedCallback(name) {
    if (name === 'message') this.updateMessage();
    if (name === 'active') this.updateActive();
  }

  updateMessage() {
    const msg = this.getAttribute('message') || 'טוען...';
    this.shadowRoot.querySelector('.text').textContent = msg;
  }

  updateActive() {
    const wrapper = this.shadowRoot.querySelector('.wrapper');
    if (this.hasAttribute('active')) wrapper.classList.add('active');
    else wrapper.classList.remove('active');
  }

  show(message = null) {
    if (message) this.setAttribute('message', message);
    this.setAttribute('active', '');
  }

  hide() {
    this.removeAttribute('active');
  }
}

customElements.define('collection-loader', CollectionLoader);
